export default [
  {
    path: '/facturacion/:customerId?',
    name: 'billing',
    component: () => import('../../views/billing/BillingList.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/nueva_razon/:customerId?',
    name: 'new-billing',
    component: () => import('../../views/billing/BillingForm.vue'),
    meta: {
      navActiveLink: 'billing',
      requiresAuth: true,
    },
  },
]
